import AxiosClient from "../../../services/axios.services";

class JobFunctionServices {
  getJobFunction = (params) =>
    AxiosClient.get("/api/app/descriptor_perfil_funcion/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getJobFunctionById = (id) =>
    AxiosClient.get(`/api/app/descriptor_perfil_funcion/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveJobFunction = (data) =>
    AxiosClient.post("/api/app/descriptor_perfil_funcion/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editJobFunction = (id, data) =>
    AxiosClient.put(`/api/app/descriptor_perfil_funcion/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  deleteJobFunction = (id) =>
    AxiosClient.delete(`/api/app/descriptor_perfil_funcion/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new JobFunctionServices();
